export const afterNextPaint = (callback: () => void) => {
  if (typeof requestAnimationFrame === "function") {
    requestAnimationFrame(() => setTimeout(callback, 0));
  } else {
    callback();
  }
};
